import { CancelledError } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getStaffListQueryOptions } from '#pages/support/staff'
import { IStaffConfirmationStatus } from '#entities/staff'

interface SupportStaffSearch {
  confirmationStatus?: IStaffConfirmationStatus
}

export const Route = createFileRoute('/support/staff')({
  loader: async ({ location, context }) => {
    const { queryClient } = context
    const search = location.search as SupportStaffSearch

    try {
      await queryClient.ensureInfiniteQueryData(getStaffListQueryOptions(search.confirmationStatus ?? null))
    } catch (error) {
      if (error instanceof CancelledError) {
        return
      }

      throw error
    }
  },

  validateSearch: (search): SupportStaffSearch => {
    const result: SupportStaffSearch = {}

    if (typeof search.confirmationStatus === 'number') {
      if (Object.values(IStaffConfirmationStatus).includes(search.confirmationStatus)) {
        result.confirmationStatus = search.confirmationStatus
      }
    }

    return result
  },
})
